import { useNavigate } from "react-router-dom";

const useAnimation = () => {
    const navigate = useNavigate();
    const wait = (ms: number | undefined) => new Promise((resolve) => setTimeout(resolve, ms));

    const slideOutItem = async (findByClass: string, id: string, navigateTo?: string) => {
        const navItems = document.querySelectorAll(findByClass);
    
        // find the specific item by id
        const targetItem = Array.from(navItems).find(
            (item) => (item as HTMLElement).id === id
        ) as HTMLElement | undefined;
    
        if (!targetItem) {
            console.warn(`Item with id ${id} not found.`);
            return;
        }
    
        const applyAnimation = (item: HTMLElement) => {
            return new Promise<void>((resolve) => {
                item.classList.remove("slideIn");
                item.classList.add("slideOut");
                resolve();
            });
        };
    
        await applyAnimation(targetItem);
    
        if (navigateTo) {
            setTimeout(() => navigate(navigateTo), 400); 
        }
    };    

    const slideOutAll = async (findByClass: string, navigateTo?: string, addWait: number = 400) => {
        const navItems = document.querySelectorAll(findByClass);
    
        const applyAnimation = (item: HTMLElement, delay: number) => {
            return new Promise<void>((resolve) => {
                setTimeout(() => {
                    item.classList.remove("slideIn");
                    item.classList.add("slideOut");
                    resolve();
                }, delay);
            });
        };
        
        // from top to bottom
        const animations = Array.from(navItems).map((item, index) => {
            return applyAnimation(item as HTMLElement, 100 * (navItems.length - index - 1)); 
        });
    
        // wait for all animations to complete
        await Promise.all(animations);

        await wait(addWait);
    
        if (navigateTo) {
            navigate(navigateTo);
        }
    };
    
    const slideIn = async (findByClass: string) => {
        const navItems = document.querySelectorAll(findByClass);
    
        const applyAnimation = (item: HTMLElement, delay: number) => {
            return new Promise<void>((resolve) => {
                setTimeout(() => {
                    item.classList.remove("slideOut");
                    item.classList.add("slideIn");
                    resolve();
                }, delay);
            });
        };
        
        // from bottom to top
        const animations = Array.from(navItems).map((item, index) => {
            const animateItems = 7; // first (count) items will be after each other animated, every other is instant
            return applyAnimation(item as HTMLElement, (index > animateItems ? 0 : 60 * ((navItems.length < animateItems ? navItems.length : animateItems) - index - 1))); 
        });
    
        // wait for all animations to complete
        await Promise.all(animations);
    }

    return {slideIn, slideOutAll, slideOutItem}
}

export default useAnimation;